import * as actionTypes from './actionTypes';
import firebase from '../../firebase';
import { setMessages } from './actionNotifications';
const setResources = ( resources ) => {
    return {
        type: actionTypes.SET_RESOURCES,
        resources: resources
    }
}

export const getResources = () => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'Resources' ).get()
            .then( ( resp ) => {
                const resourceList = [];
                resp.forEach( item => {
                    const resource = item.data();
                    resource.key = item.id;
                    resourceList.push( resource );
                } )
                dispatch( setResources( resourceList ) );
            } ).catch( ( err ) => {
                dispatch( setMessages( 'Error Getting Resources', 'error' ) );
                console.log( err );
            } )
    }
}

const resourceUpdated = () => {
    return {
        type: actionTypes.RESOURCE_UPDATED
    }
}

export const updateResources = ( key, resource ) => {
    return dispatch => {
        const db = firebase.firestore();
        if( key ) {
            db.collection( 'Resources' ).doc( key ).update( resource )
                .then( resp => {
                    dispatch( resourceUpdated() );
                    dispatch( getResources() );
                } )
                .catch( err => {
                    dispatch( setMessages( 'Error updating Resource', 'error' ) );
                    console.log( err );
                } )
        } else {
            db.collection( 'Resources' ).add( resource )
                .then( resp => {
                    dispatch( resourceUpdated() );
                    dispatch( getResources() );
                } )
                .catch( err => {
                    dispatch( setMessages( 'Error updating Resource', 'error' ) );
                    console.log( err );
                } )
        }
    }
}

const resourceRemoved = () => {
    return {
        type: actionTypes.RESOURCE_REMOVED
    }
}

export const removeResource = ( key ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'Resources' ).doc( key ).delete()
            .then( resp => {
                dispatch( resourceRemoved() );
                dispatch( getResources() );
                db.collection( 'ResourceCalendar' ).get()
                    .then( resp => {
                        resp.forEach( item => {
                            const reservation = item.data();
                            if( reservation.resource === key ) {
                                dispatch( removeResourceEvent( item.id ) );
                            }
                        } )
                    } )
                    .catch( err => {
                        dispatch( setMessages( 'Error deleting Reservations', 'error' ) );
                        console.log( err );
                    } )
            } )
            .catch( err => {
                dispatch( setMessages( 'Error deleting Resource', 'error' ) );
                console.log( err );
            } )
    }
}

const setReservations = ( reservations ) => {
    return {
        type: actionTypes.SET_RESERVATIONS,
        reservations: reservations
    }
}

export const getReservations = () => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'ResourceCalendar' ).get()
            .then( resp => {
                const reservationList = [];
                resp.forEach( item => {
                    const reservation = item.data();
                    reservation.startTime = reservation.startTime.toMillis();
                    reservation.endTime = reservation.endTime.toMillis();
                    reservation.key = item.id;
                    reservationList.push( reservation );
                } )
                //console.log('current',reservationList);
                //dispatch(importGoogleEvents());
                dispatch( setReservations( reservationList ) );

            } ).catch( err => {
                dispatch( setMessages( 'Error getting reservations', 'error' ) );
                console.log( err );
            } )
    }
}

const resourceEventAdded = () => {
    return {
        type: actionTypes.ADD_RESOURCE_EVENT
    }
}

export const addResourceEvent = ( event ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'ResourceCalendar' ).add( event )
            .then( () => {
                dispatch( resourceEventAdded() );
                dispatch( getReservations() );
            } ).catch( err => {
                dispatch( setMessages( 'Error adding event', 'error' ) );
            } )
    }
}

const resourceEventRemoved = () => {
    return {
        type: actionTypes.REMOVE_RESOURCE_EVENT
    }
}

export const removeResourceEvent = ( eventId ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'ResourceCalendar' ).doc( eventId ).delete()
            .then( () => {
                dispatch( resourceEventRemoved() );
                dispatch( getReservations() );
            } ).catch( err => {
                dispatch( setMessages( 'Error Deleting Event', 'error' ) )
            } )
    }
}

const labHoursGot = ( open, close ) => {
    return {
        type: actionTypes.LAB_HOURS_GOT,
        open: open,
        close: close
    }
}

export const getLabHours = () => {
    return dispatch => {
        let openTime = null;
        let closeTime = null;
        const db = firebase.firestore();
        db.collection( 'LabHours' ).doc( 'closeTime' ).get()
            .then( resp => {
                let foo = resp.data();
                closeTime = foo.time;
                db.collection( 'LabHours' ).doc( 'openTime' ).get()
                    .then( resp => {
                        let bar = resp.data();
                        openTime = bar.time;
                        dispatch( labHoursGot( openTime, closeTime ) )
                    } ).catch( err => {
                        dispatch( setMessages( 'Error getting hours', 'error' ) );
                        console.log( err );
                    } )
            } ).catch( err => {
                dispatch( setMessages( 'Error getting hours', 'error' ) );
                console.log( err );
            } )
    }
}

const labHoursChanged = () => {
    return {
        type: actionTypes.LAB_HOURS_SET
    }
}

export const setLabHours = ( openTime, closeTime ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'LabHours' ).doc( 'closeTime' ).update( { time: closeTime } )
            .then( () => {
                db.collection( 'LabHours' ).doc( 'openTime' ).update( { time: openTime } )
                    .then( () => {
                        dispatch( labHoursChanged() );
                        dispatch( getLabHours() );
                    } )
                    .catch( err => {
                        dispatch( setMessages( 'Error setting hours', 'error' ) );
                        console.log( err );
                    } )
            } )
            .catch( err => {
                dispatch( setMessages( 'Error setting hours', 'error' ) );
                console.log( err );
            } )
    }
}